import CHATBOT_SETTINGS_TYPES from './_actionTypes';

const initialState = {
  settings: null,
  usageStats: [],
  daysFilter: 30,
  settingsLoading: false,
  saving: false,
  statsLoading: false,
  error: null,
  saveError: null,
  statsError: null,
};

const chatbotSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHATBOT_SETTINGS_TYPES.FETCH_SETTINGS_REQUEST:
      return { ...state, settingsLoading: true, error: null };

    case CHATBOT_SETTINGS_TYPES.FETCH_SETTINGS_SUCCESS:
      return { ...state, settingsLoading: false, settings: action.payload.settings };

    case CHATBOT_SETTINGS_TYPES.FETCH_SETTINGS_FAILURE:
      return { ...state, settingsLoading: false, error: action.payload.error };

    case CHATBOT_SETTINGS_TYPES.UPDATE_SETTINGS_REQUEST:
      return { ...state, saving: true, saveError: null };

    case CHATBOT_SETTINGS_TYPES.UPDATE_SETTINGS_SUCCESS:
      return { ...state, saving: false, settings: action.payload.settings };

    case CHATBOT_SETTINGS_TYPES.UPDATE_SETTINGS_FAILURE:
      return { ...state, saving: false, saveError: action.payload.error };

    case CHATBOT_SETTINGS_TYPES.FETCH_USAGE_STATS_REQUEST:
      return { ...state, statsLoading: true, statsError: null };

    case CHATBOT_SETTINGS_TYPES.FETCH_USAGE_STATS_SUCCESS:
      return { ...state, statsLoading: false, usageStats: action.payload.stats };

    case CHATBOT_SETTINGS_TYPES.FETCH_USAGE_STATS_FAILURE:
      return { ...state, statsLoading: false, statsError: action.payload.error };

    case CHATBOT_SETTINGS_TYPES.SET_DAYS_FILTER:
      return { ...state, daysFilter: action.payload.days };

    default:
      return state;
  }
};

export default chatbotSettingsReducer;
